/*
 * Module for the _PaymentHistory partial view
*/
rs.module("ui/content/benefits/paymenthistory/paymenthistory",

    [],

    function () {

        // Initialize the module
        function initialize(listApi, backendUrls) {

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {

                // Set title based on if list item is a payment detail or YTD
                listApi.detail.updateTitle(context.PaymentRegisterKey ? "Payment Information" : "Year to Date Breakdown");

                getDetail(context)
                    .done(function (html) {
                        listApi.detail.loadDetail(html);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });

            // make call get the detail to be shown
            function getDetail(context) {
                if (context.PaymentRegisterKey) {
                    return $.get(backendUrls.getPaymentHistoryDetail, { paymentRegisterKey: context.PaymentRegisterKey, payrollDate: context.PayrollDate });
                }
                else {
                    return $.get(backendUrls.getYearToDateDetail, { year: context.Year });
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);